import { all, call, put, select, takeLeading } from "redux-saga/effects";
import i18n from "i18next";
import { loadScript } from "../../../services/dynamic-script";
import { ee, initializeEEConnection } from "../../../services/earth-engine";
import * as Auth from "./header";
import { Actions as Snack } from "../snacks";

// const AUTH_PARAMS = {
//   client_id: process.env.REACT_APP_CLIENT_ID,
//   scope:
//     "https://www.googleapis.com/auth/earthengine.readonly" /*ee.apiclient.AUTH_SCOPE + ${ee.apiclient.STORAGE_SCOPE} */,
//   redirect_uri: "http://localhost:5001",
// };

/**
 * Funtions added to new authentication from google 2023
 */
let client = null;
let access_token = null;
let userData = null;
// let callBackLogin = null;
// function getToken(callback) {
//   callBackLogin = callback;
//   client.requestAccessToken();
// }
async function getToken(callback) {
  console.log("[ducks/auth] Requesting access token from backend...");
  try {
    const response = await fetch(
      "https://app.wildfireriskcarbon.org/api/auth/usfs",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (!response.ok) {
      throw new Error(
        "Failed to authenticate with backend. Status: " + response.status
      );
    }

    const data = await response.json();
    const { token, user } = data;

    if (!token || !user) {
      throw new Error("Backend response is missing 'token' or 'user' fields.");
    }

    console.log("[ducks/auth] Access token retrieved from backend:", token);
    if (callback) {
      callback(token, user); // Pass token and user to the callback
    }
  } catch (error) {
    console.error("[ducks/auth] Error during backend token retrieval:", error);
    throw error;
  }
}

function revokeToken() {
  window.google.accounts.oauth2.revoke(access_token, () => {
    console.log("access token revoked");
  });
}
/**
 * Asynchronously loads and initiates auth2 client.
 * @returns {Promise}
 */

// NEW BACKEND AUTH

const gapiLoadAuth2 = async () => {
  return new Promise(async (resolve, reject) => {
    console.log("[ducks/auth] Starting gapiLoadAuth2...");

    try {
      // Call the backend API to fetch the token
      const response = await fetch(
        "https://app.wildfireriskcarbon.org/api/auth/usfs",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to authenticate with backend. Status: " + response.status
        );
      }

      // Parse the response
      const data = await response.json();
      const { token, user } = data;

      if (!token || !user) {
        throw new Error(
          "Backend response is missing 'token' or 'user' fields."
        );
      }

      console.log("[ducks/auth] Token from backend:", token);
      console.log("[ducks/auth] User from backend:", user);

      // Use the token to authenticate with Earth Engine
      ee.data.setAuthToken(
        null, // Client name (null for backend-managed tokens)
        "Bearer",
        token, // Token received from the backend
        3600 * 6, // Expiration time (match token's validity)
        [],
        () => {
          const authToken = ee.data.getAuthToken();
          console.log("[EarthEngineService] Current auth token:", authToken);

          ee.initialize(
            null,
            null,
            () => {
              console.log(
                "[ducks/auth] Earth Engine initialized successfully."
              );
              resolve({ token, user }); // Resolve the promise with the token and user info
            },
            (err) => {
              console.error(
                "[ducks/auth] Earth Engine initialization failed:",
                err
              );
              reject(err); // Reject the promise if Earth Engine fails to initialize
            }
          );
        },
        (err) => {
          console.error("[ducks/auth] Error setting Earth Engine token:", err);
          reject(err); // Reject the promise if token setting fails
        }
      );
    } catch (error) {
      console.error("[ducks/auth] Error during backend authentication:", error);
      reject(error); // Reject the promise for any error
    }
  });
};

const loadClientAuth = function* ({ payload: { onSuccess } }) {
  try {
    console.log("[ducks/auth] Starting authentication process...");
    const { token, user } = yield call(gapiLoadAuth2);

    // Dispatch success actions
    yield put(Auth.Actions.loadClientAuthSuccess());
    console.log("[ducks/auth] Authentication successful. User:", user);

    onSuccess(); // Execute the success callback if provided
  } catch (e) {
    console.error("[ducks/auth] Authentication failed:", e);
    yield put(Auth.Actions.loadClientAuthFailure(e));
  }
};

const loadClientAuthSuccess = function* () {
  // Load success
};

// eslint-disable-next-line require-yield
const loadClientAuthFailure = function* () {
  // Display notification
  //console.error("[ducks/auth] LOAD ERROR: Not able to load client:auth2");
};

let callBackLogin = function* (accessToken, user) {
  console.log(
    "[ducks/auth] Authorization callback triggered with token:",
    accessToken
  );
  if (!user) {
    console.error("[ducks/auth] Missing user data during callback.");
    return;
  }

  try {
    // Initialize Earth Engine with the token
    yield call(initializeEEConnection, accessToken);
    console.log("[ducks/auth] Earth Engine connection initialized with token.");

    // Update Redux state with user data
    yield put(Auth.Actions.authorize(user.name, user.picture));
  } catch (e) {
    console.error("[ducks/auth] Error during Earth Engine initialization:", e);
    yield put(Auth.Actions.authorizeFailure(e));
  }
};

const begin = function* ({ payload: { callback } }) {
  console.log("[ducks/auth] Starting authentication process...");
  const signedUser = yield select((state) => state.auth.user);

  if (!signedUser) {
    console.log("[ducks/auth] No signed user found, initiating login...");

    try {
      // Retrieve token and user info from the backend
      yield call(() =>
        getToken((token, user) => {
          console.log("[ducks/auth] Token retrieved, invoking callback...");
          call(callBackLogin, token, user); // Pass token and user to the callback
        })
      );

      // Navigate to main page upon success
      if (callback) callback();
    } catch (error) {
      console.error("[ducks/auth] Error during authorization:", error);
      yield put(Auth.Actions.authorizeFailure(error));
    }
  } else {
    console.log("[ducks/auth] Signed user already exists:", signedUser);
    yield put(Auth.Actions.authorize(signedUser.name, signedUser.imageUrl));
  }
};

const authorizeFailure = function* ({
  payload: {
    error: { error },
  },
}) {
  console.error(`[ducks/auth] AUTH ERROR: Not able to sign in due to ${error}`);

  yield put(Snack.error("signin-task-error", `Error: ${error}`));
  yield put(Snack.dismiss("signin-task"));
};

// eslint-disable-next-line require-yield
const revoke = function* ({ payload: { callback } }) {
  if (true) {
    //old code: //window.gapi && window.gapi.auth2
    revokeToken(); //old code: window.gapi.auth2.getAuthInstance().disconnect();
    ee.data.clearAuthToken();
    callback();
  }
};

const root = function* () {
  yield all([
    takeLeading(Auth.Types.LOAD_CLIENT_AUTH, loadClientAuth),
    takeLeading(Auth.Types.LOAD_CLIENT_AUTH_SUCCESS, loadClientAuthSuccess),
    takeLeading(Auth.Types.LOAD_CLIENT_AUTH_FAILURE, loadClientAuthFailure),
    takeLeading(Auth.Types.BEGIN, begin),
    takeLeading(Auth.Types.AUTHORIZE_FAILURE, authorizeFailure),
    takeLeading(Auth.Types.REVOKE, revoke),
  ]);
};

export default root;
